import React, { ReactNode } from 'react'

import { alpha, Box, CircularProgress, Stack, SxProps } from '@mui/material'
import { isString } from 'lodash'

import { EmptyData } from '../../pages/Reports'

import WidgetSubtitle from './WidgetSubtitle'
import WidgetTitle from './WidgetTitle'

export type BigWidgetWrapperWrapperPropTypes = {
  children: ReactNode
  isLoading?: boolean
  isEmpty?: boolean
  oldEmptyIcon?: boolean
  emptyTitle?: string | null
  emptySubtitle?: string | null
  title?: string | null
  titleAction?: ReactNode
  explanation?: string | null
  subtitle?: string | null
  disablePadding?: boolean
  withBorder?: boolean
  fullHeight?: boolean
  autoHeight?: boolean
  bgColor?: string
  borderColor?: string

  sx?: SxProps
}

export const BigWidgetWrapper: React.FC<BigWidgetWrapperWrapperPropTypes> = ({
  children,
  isLoading = false,
  isEmpty,
  oldEmptyIcon = false,
  emptyTitle,
  emptySubtitle,
  title,
  titleAction,
  explanation,
  subtitle,
  disablePadding = false,
  withBorder = false,
  fullHeight = false,
  autoHeight = false,
  bgColor,
  borderColor,
  sx,
}) => {
  return (
    <Stack direction={'column'} spacing={2} width={'100%'} height={'100%'}>
      {isString(title) && (
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: titleAction ? 0.5 : 0 }}
        >
          <WidgetTitle explanation={explanation}>{title}</WidgetTitle>
          {titleAction}
        </Stack>
      )}
      {isString(subtitle) && (
        <WidgetSubtitle sx={{ mt: titleAction ? `8px !important` : `0 !important` }}>
          {subtitle}
        </WidgetSubtitle>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: autoHeight ? 'stretch' : 'center',
          justifyContent: autoHeight ? 'flex-start' : 'center',
          width: '100%',
          height: autoHeight
            ? 'auto'
            : (theme) => ({
                xs: fullHeight ? '100%' : theme.spacing(28),
                sm: fullHeight ? '100%' : theme.spacing(42.25),
                lg: fullHeight ? '100%' : theme.spacing(60),
              }),
          backgroundColor: (theme) =>
            bgColor || alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
          borderRadius: (theme) => theme.spacing(0.5),
          ...(withBorder && {
            border: (theme) =>
              `2px solid ${
                borderColor ||
                alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
              }`,
          }),
          ...(!disablePadding && { padding: (theme) => theme.spacing(1) }),
          ...sx,
        }}
      >
        {isLoading ? (
          <CircularProgress disableShrink />
        ) : isEmpty ? (
          <EmptyData newIcon={!oldEmptyIcon} title={emptyTitle} subtitle={emptySubtitle} />
        ) : (
          children
        )}
      </Box>
    </Stack>
  )
}

export default BigWidgetWrapper
